.tag {
  padding: 0.25rem 0.5rem;
  padding-left: 0.5rem;
  background-color: #fff;
  color: #000;
  margin-left: 1rem;
  font-size: 0.6rem;
  text-transform: uppercase;
  font-weight: 600;
  display: inline-block;
}

.tag.inverse {
  background-color: #555;
  color: #fff;
}
